export default "__VITE_ASSET__Nlk1YwFo__"